import axios from 'axios';
import { environment } from 'environments/environment';

const mainAxios = axios.create({
  baseURL: environment.integration.rootUrl,
});

export const unAuthedAxios = axios.create({
  baseURL: environment.integration.rootUrl,
});


export const firebaseAxios = axios.create({
  baseURL: environment.integration.firebaseFunction,
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

mainAxios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('id_token');
  config.headers.Authorization = 'Bearer ' + token;
  return config;
});

mainAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default mainAxios;
